import { useCallback, useEffect, useState } from "react";
import DueDateTable from "../components/DueDateTable";
import { BlacklistDialog } from "../components/LoanDialogs";
import SalesScopeSelector from "../components/SalesScopeSelector";
import api from "../lib/api";
export default function CollectionsPage() {
  const [loans, setLoans] = useState([]);
  const [scopeId, setScopeId] = useState("");
  const [blacklist, setBlacklist] = useState(null);
  const load = useCallback(async () => {
    const response = await api.get(`/loans${scopeId ? `?owner_id=${scopeId}` : ""}`);
    setLoans(response.data);
  }, [scopeId]);

  useEffect(() => {
    load();
  }, [load]);

  return <div className="page" data-testid="collections-page"><header className="page-header"><div><div className="eyebrow">Action queue</div><h1>Due Date</h1><p>Open a loan for full repayment tracking or blacklist an account when required.</p></div></header><SalesScopeSelector value={scopeId} onChange={setScopeId} testId="due-date-agent-select" /><DueDateTable loans={loans} onBlacklist={setBlacklist} /><BlacklistDialog loan={blacklist} onClose={() => setBlacklist(null)} onDone={load} /></div>;
}